import commonZhHK from './common_zh-HK'

const fnbZhHK = {
  fnb: {
    ...commonZhHK,
  }
}

export default fnbZhHK